import {ActionEmitterService} from "../shared/services/action-emitter.service";

export class WebsiteSidebarItem {
  public name: string;
  public label: string;
  public type: string;
  public img?: string;
  public icon?: string;
  public path?: string;
  public beta?: boolean;
  public advanced?: boolean;
  public disabled: boolean;
  public hidden: boolean = false;
  public notification: boolean = false;
  private readonly actions?: string[];

  constructor(
    name: string,
    label: string,
    img?: string,
    icon?: string,
    path?: string,
    actions?: string[],
    disabled?: boolean,
    beta?: boolean,
    notification?: boolean,
    advanced?: boolean,
  ) {
    this.name = name;
    this.label = label;
    img && (this.img = img);
    icon && (this.icon = icon);
    path && (this.path = path);
    beta && (this.beta = beta);
    advanced && (this.advanced = advanced);
    if (actions && actions.length) {
      this.actions = actions;
    }
    this.type = 'simple';
    this.disabled = disabled;
    notification && (this.notification = notification);
  }

  public emitActions(): void {
    this.actions && this.actions.length && this.actions.forEach(action => ActionEmitterService.emitActions(action));
  }
}

export const builder: WebsiteSidebarItem = new WebsiteSidebarItem('builder', 'text_ai-builder.title', 'assets/images/menu-icons/builder.svg', '', '/ai-builder', null, null);

export const boosterMain: WebsiteSidebarItem = new WebsiteSidebarItem('frontend', 'text_main', null, 'db-icon-ds-laptop', '/booster/frontend');

export const boosterMainDisabled: WebsiteSidebarItem = new WebsiteSidebarItem('disabled', 'text_main', null, 'db-icon-ds-laptop', '/booster/disabled');

export const boosterPages: WebsiteSidebarItem = new WebsiteSidebarItem('pages', 'text_speedOptimizerPages', null, 'db-icon-ds-page', '/booster/pages');

export const boosterImageOptimizer: WebsiteSidebarItem = new WebsiteSidebarItem('image-optimizer', 'text_imageOptimizer', null, 'db-icon-ds-images', '/booster/image-optimizer');

export const boosterCloudflare: WebsiteSidebarItem = new WebsiteSidebarItem('cloudflare', 'text_speedOptimizerCloudflare', null, 'db-icon-ds-cloudflare-small', '/booster/cloudflare');

export const boosterSettings: WebsiteSidebarItem = new WebsiteSidebarItem('settings', 'text_settings', null, 'db-icon-ds-settings', '/booster/settings', null, null, true, true);

export const boosterHostingPerformance: WebsiteSidebarItem = new WebsiteSidebarItem('backend', 'text_speedOptimizerBackEnd', null, 'db-icon-ds-performance', '/booster/hosting-performance');

export const boosterHostingPerformanceForHosted: WebsiteSidebarItem = new WebsiteSidebarItem('hosting-performance:', 'text_speedOptimizerBackEnd', null, 'db-icon-ds-performance', '/hosting/hosting-performance');

export const boosterWhiteLabel: WebsiteSidebarItem = new WebsiteSidebarItem('boosterWhiteLabel', 'text_white-label', 'assets/images/menu-icons/white-label.svg', null, '/booster/white-label');

export const boosterPro: WebsiteSidebarItem = new WebsiteSidebarItem('boosterPro', 'text_speedOptimizerPro', null, 'db-icon-ds-diamond', '/booster/pro', null, null, true );

export const boosterDisconnected: WebsiteSidebarItem = new WebsiteSidebarItem('boosterDisabled', 'text_speedOptimizer', 'assets/images/menu-icons/website-booster.svg', null, '/booster/disabled');

export const mySites: WebsiteSidebarItem = new WebsiteSidebarItem('mySites', 'text_mySites', 'assets/images/menu-icons/my_sites.svg', null, '/my-sites');

export const main: WebsiteSidebarItem = new WebsiteSidebarItem('main', 'text_main', 'assets/images/menu-icons/overview.svg', null, '/main');

export const credentials: WebsiteSidebarItem = new WebsiteSidebarItem('credentials', 'text_hosting.info', null, 'db-icon-ds-info-bg', '/hosting/info', null, null, null, null, true);

export const domains: WebsiteSidebarItem = new WebsiteSidebarItem('domains', 'text_hosting.domains', null, 'db-icon-ds-domains', '/domains', null, null, null, null, true);

export const pointDomain: WebsiteSidebarItem = new WebsiteSidebarItem('pointDomain', 'text_hosting.domainNotPointed', 'assets/images/icons/point_domain.svg', null, '/domains', null, null, null, null, true);

export const tools: WebsiteSidebarItem = new WebsiteSidebarItem('tools', 'text_hosting.tools', null, 'db-icon-ds-tools', '/hosting/tools', null, null, null, null, true);

export const redirects: WebsiteSidebarItem = new WebsiteSidebarItem('redirects', 'text_hosting.redirects', null, 'db-icon-ds-redirect', '/hosting/redirects', null, null, null, null, true);

export const restore: WebsiteSidebarItem = new WebsiteSidebarItem('restore', 'text_hosting.restore', null, 'db-icon-ds-restore', '/hosting/restore', null, null, null, null, true);

export const resource: WebsiteSidebarItem = new WebsiteSidebarItem('resource', 'text_hosting.resource-usage', null, 'db-icon-ds-resource-usage', '/hosting/resource-usage', null, null, null, null, true);

export const logs: WebsiteSidebarItem = new WebsiteSidebarItem('logs', 'text_logs', null, 'db-icon-ds-logs', '/hosting/logs', null, null, null, null, true);

export const staging: WebsiteSidebarItem = new WebsiteSidebarItem('staging', 'text_stagingEnvironment', null, 'db-icon-ds-settings', '/hosting/environment', null, null, null, null, true);

export const stagingEnabled: WebsiteSidebarItem = new WebsiteSidebarItem('staging', 'text_stagingEnvironment', null, 'db-icon-ds-settings', '',
  [JSON.stringify({name: 'changeEnv', args: [true]})], null, null, null, true);

export const manage: WebsiteSidebarItem = new WebsiteSidebarItem('manage', 'text_hosting.manage_environment', null, 'db-icon-ds-settings', '/hosting/manage-environment', null, null, null, null, true);

export const recreate: WebsiteSidebarItem = new WebsiteSidebarItem('recreate', 'text_ai-builder.recreate-menu', null, 'db-icon-ds-recreate', '/builder/recreate-website');

/*
export const templates: WebsiteSidebarItem = new WebsiteSidebarItem('templates', 'text_ai-builder.templates', 'assets/images/menu-icons/templates.svg', 'db-icon-ds-templates', '/builder/templates');
*/

export const plugins: WebsiteSidebarItem = new WebsiteSidebarItem('plugins', 'text_managerWPPlugins', null, null, '/plugins');

export const themes: WebsiteSidebarItem = new WebsiteSidebarItem('themes', 'text_managerWPThemes', null, null, '/themes');

export const backup: WebsiteSidebarItem = new WebsiteSidebarItem('backup', 'text_backups', 'assets/images/menu-icons/backups.svg', null, '/backup');

export const security: WebsiteSidebarItem = new WebsiteSidebarItem('security', 'text_security', 'assets/images/menu-icons/security.svg', null, '/security');

export const seo: WebsiteSidebarItem = new WebsiteSidebarItem('seo', 'text_seo', 'assets/images/menu-icons/seo.svg', null, '/seo');

export const seoOverview: WebsiteSidebarItem = new WebsiteSidebarItem('seoOverview', 'text_seo-overview', null, 'db-icon-ds-overview', '/seo/seo-overview');

export const seoSearch: WebsiteSidebarItem = new WebsiteSidebarItem('seoSearch', 'text_search-analytics', null, 'db-icon-ds-search', '/seo/search-analytics');

export const imageOptimizer: WebsiteSidebarItem = new WebsiteSidebarItem('imageOptimizer', 'text_imageOptimizer', 'assets/images/menu-icons/image_optimizer.svg', null, '/image-optimizer');

export const whiteLabel: WebsiteSidebarItem = new WebsiteSidebarItem('whiteLabel', 'text_white-label', 'assets/images/menu-icons/white-label.svg', null, '/white-label');

export const referralProgram: WebsiteSidebarItem = new WebsiteSidebarItem('referralProgram', 'text_referralProgram', 'assets/images/menu-icons/refer-friend-menu.svg', null, 'referral-system/program');
